import React from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';

import { Theme } from 'ui_system/theme';

import {
  getLocation,
  isResourceCreateExperienceEnabled,
} from 'data_system/resource_portal/selectors';
import { SLOT_LIST, EXPERIENCE_LIST } from '../routes/routes';

const { tinyMobileBreakpointWidth } = Theme.mobile;

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  height: 65px;
  border-bottom: 1px solid ${Theme.colors.lightLine};

  padding: 0px 24px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding: 0px 8px;
  }
  @media (max-width: ${tinyMobileBreakpointWidth}px) {
    padding: 0px 8px;
  }
`;

const Tab = styled.div`
  background: white;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  box-shadow: ${(props) =>
    props.active
      ? `inset 0px -3px 0px 0px ${props.theme.buttonBackgroundColor}`
      : 'none'};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding: 12px 24px;
  }
  @media (max-width: ${tinyMobileBreakpointWidth}px) {
    padding: 12px;
  }
`;

const TabNavigation = ({ t }) => {
  const dispatch = useDispatch();
  const { pathname } = useSelector(getLocation);
  const createExperienceEnabled = useSelector(
    isResourceCreateExperienceEnabled
  );

  const enabledPaths = [SLOT_LIST];
  if (createExperienceEnabled) {
    enabledPaths.push(EXPERIENCE_LIST);
  }

  if (!enabledPaths.includes(pathname)) return null;

  return (
    <Container>
      <Tab
        active={pathname === SLOT_LIST}
        onClick={() => dispatch(replace(SLOT_LIST))}
      >
        {t('SCHEDULED_CLASSES')}
      </Tab>
      {createExperienceEnabled && (
        <Tab
          active={pathname === EXPERIENCE_LIST}
          onClick={() => dispatch(replace(EXPERIENCE_LIST))}
        >
          {t('MY_CLASSES')}
        </Tab>
      )}
    </Container>
  );
};

export default TabNavigation;
